import { c } from '@ui-components/utils/tailwind-merge';
import { MiniCartLiveRegionProps } from './MiniCartLiveRegion.types';

/**
 * Polite, visually hidden region for the cart count and mini-cart errors.
 * Keyed per announcement so a repeated message is read again. A span, as
 * the header renders it inside its inline wrapper.
 */
export const MiniCartLiveRegion = ({
  announcement,
  className = '',
}: MiniCartLiveRegionProps) => (
  <span
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-test="mini-cart-live-region"
    className={c('sr-only', className)}
  >
    {announcement && <span key={announcement.id}>{announcement.message}</span>}
  </span>
);
